"use client";

import * as React from "react";
import { X } from "lucide-react";
import { cn } from "../cn";

export type FiltersToolbarProps = {
  /** Filter inputs (FilterSearch, FilterSelect, ...). Rendered on the left. */
  children: React.ReactNode;
  /** Right-aligned action slot (e.g. "+ Create" button). */
  actions?: React.ReactNode;
  /** Show "Clear all" button. */
  hasActiveFilters?: boolean;
  onClearAll?: () => void;
  className?: string;
};

export function FiltersToolbar({
  children,
  actions,
  hasActiveFilters,
  onClearAll,
  className,
}: FiltersToolbarProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
    >
      <div className="flex flex-1 flex-wrap items-center gap-2">
        {children}
        {hasActiveFilters && onClearAll ? (
          <button
            type="button"
            onClick={onClearAll}
            className="inline-flex h-8 items-center gap-1 rounded-full px-2.5 text-xs font-semibold text-ash hover:bg-mist hover:text-ink"
          >
            <X size={13} strokeWidth={2.25} />
            Xoá bộ lọc
          </button>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
